import { IHrDepartmentData } from '@/models';
import { IHrDepartmentService } from './hr-department.types';
import { AxiosInstance } from 'axios';

export class HrDepartmentService implements IHrDepartmentService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/hr-departments/';
  }

  fetchHrDepartments(): Promise<IHrDepartmentData[]> {
    return this.axios
      .get<IHrDepartmentData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchHrDepartment(id: number): Promise<IHrDepartmentData> {
    return this.axios
      .get<IHrDepartmentData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createHrDepartment(data: IHrDepartmentData): Promise<IHrDepartmentData> {
    return this.axios
      .post<IHrDepartmentData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateHrDepartment(data: IHrDepartmentData): Promise<IHrDepartmentData> {
    return this.axios
      .patch<IHrDepartmentData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteHrDepartment(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
